import { apiEndPoint, apiKey, cdnEndPoint } from "./configurations";
import { isJson } from "./misc";
import { msalInstance } from "..";
import { acquireTokenSilently, isTokenExpired } from "./auth/auth";

//------------- BEGIN: CDN Content -------------
export async function cdnGetRequest(path: string){
    let cdnBaseUri = cdnEndPoint();
    console.log(cdnBaseUri); 
    return fetch(cdnBaseUri+path,{
        headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            }
    }).then(async (response) => {
        let data = await response.json();
        return data;
    })
    .catch((error) => {
        console.error('Error fetching data:', error);
    });
}
//------------- END:   CDN Content -------------
//------------- BEGIN: API Content -------------

export async function apiGetRequest(path: string, body: any):Promise<any>{
    //let tokenClaims = msalInstance.getActiveAccount()?.idTokenClaims;
    let apiBaseUri = apiEndPoint();
    let key = apiKey();
    return fetch(apiBaseUri+"api/"+path,{
        method: "GET",
        headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'x-functions-key': key===undefined?"":key,
            'Authorization': await GetBearerToken()//tokenClaims===undefined?"":`Bearer ${msalInstance.getActiveAccount()?.idToken}`
            }
    }).then(async (response) => {
        let data = await response.json();
        return data;
    })
    .catch((error) => {
        console.error('Error fetching data:', error);
        return null;
    });
}

export async function apiPostRequest(path: string, body: any):Promise<any>{
    //let tokenClaims = msalInstance.getActiveAccount()?.idTokenClaims;
    let apiBaseUri = apiEndPoint();
    let key = apiKey();
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'x-functions-key': key===undefined?"":key,
            'Authorization': await GetBearerToken() //tokenClaims===undefined?"":`Bearer ${msalInstance.getActiveAccount()?.idToken}`
            },
        body: typeof body === "string"? body: JSON.stringify(body)
    };
    return fetch(apiBaseUri+"api/"+path, requestOptions).then(async (response) => {
        let data = await response.text();
        if(isJson(data)===true){
            return JSON.parse(data);
        }
        else{
            return data;
        }
    })
    .catch((error) => {
        console.error('Error fetching data:', error);
        return null;
    });
    
}
export async function GetBearerToken(){

    var tokenStringified=JSON.stringify(msalInstance.getActiveAccount()?.idToken);
    tokenStringified=JSON.parse(tokenStringified);
    let isTokenExpiredCheckResult:boolean=true;
    if(msalInstance.getActiveAccount()?.idToken!==undefined||msalInstance.getActiveAccount()?.idToken!==null){
        isTokenExpiredCheckResult=isTokenExpired(tokenStringified);
    }
    if(!isTokenExpiredCheckResult){
        await acquireTokenSilently();
    }
    let tokenClaims = msalInstance.getActiveAccount()?.idTokenClaims;
    return tokenClaims===undefined?"":`Bearer ${msalInstance.getActiveAccount()?.idToken}`
}
//------------- END:   API Content -------------